<template>
  <FormContainer without-divider>
    <template #title>Établissement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_2"
          :model-value="model?.employeur?.etablissement?.denomination"
          label="Raison sociale"
          class="col-22 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_3"
          :model-value="model?.employeur?.etablissement?.siret?.valeur"
          label="Siret de l'établissement d'exécution du contrat"
          class="col-14 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared'
  import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const { model } = storeToRefs(store)
</script>
